import { useDisclosure } from "@msuite/ui/hooks";
import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import React from "react";
import { useForm } from "react-hook-form";
import { client } from "@/hono";
import { AddContactMemberModal } from "@/modals/contacts/add-contact-member-modal";

/** Props Interface */
interface ProtocolFormRecipientAdderProps {
	onSelect: (item: { type: "user" | "contactMember"; id: string }) => void;
}

export function ProtocolFormRecipientAdder({ onSelect }: ProtocolFormRecipientAdderProps) {
	/** Hooks */
	const methods = useForm();
	const addContactMember = useDisclosure();

	/** Query */
	const { refetch } = useQuery({
		queryKey: ["contact-members"],
		queryFn: async () => {
			const response = await client.contacts.members.$get();
			const data = await responseHandler(response);
			return data.contactMembers;
		},
	});

	/** Render */
	return (
		<React.Fragment>
			<AddContactMemberModal
				isOpen={addContactMember.isOpen}
				onClose={addContactMember.onClose}
				onComplete={async (contact) => {
					await refetch();
					if (contact?.id) {
						methods.reset();
						onSelect({
							type: "contactMember",
							id: contact.id,
						});
					}
				}}
				contactId={null}
			/>
		</React.Fragment>
	);
}
